import { API_GET_ACCOUNT_PRODUCTS } from './types';

import { accountProducts as apiAccountProducts } from '@/api/routes';

import apiClient from '@/modules/ApiClient';

const state = {
  isFetching: false,
  error: false,
  products: [],
};

const getters = {};

const mutations = {
  [API_GET_ACCOUNT_PRODUCTS.REQUEST](state) {
    state.isFetching = true;
    state.error = null;
  },
  [API_GET_ACCOUNT_PRODUCTS.SUCCESS](state, products) {
    state.products = products;
    state.isFetching = false;
    state.error = null;
  },
  [API_GET_ACCOUNT_PRODUCTS.ERROR](state, error) {
    state.isFetching = false;
    state.error = error;
  },
};

const actions = {
  async [API_GET_ACCOUNT_PRODUCTS.REQUEST]({ commit }, accountId) {
    try {
      commit(API_GET_ACCOUNT_PRODUCTS.REQUEST);

      const { data } = await apiClient.request({
        method: 'GET',
        url: apiAccountProducts,
        pathParams: {
          accountId,
        },
      });

      commit(API_GET_ACCOUNT_PRODUCTS.SUCCESS, data);
    } catch (error) {
      commit(API_GET_ACCOUNT_PRODUCTS.ERROR, error);
    }
  },
};

const productsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default productsModule;
